export default "__VITE_ASSET__DwIZVhEL__"